<template>
    <div class="de-introduce-wrapper" :style="fontStyle">
        <p>{{title}}</p>
        <p>
            {{preContent}}
            <span class="num" :style="{'font-size': `${fontObj&&fontObj.fontSize+4}px`}">{{number}}</span>
            {{postContent}}
        </p>
    </div>
</template>

<script>
export default {
    name: 'de-introduce',
    props: {
        title: {
            type: String,
            default: '标题'
        },
        number: {
            type: String,
            default: '数字/文本'
        },
        preContent: {
            type: String,
            default: ''
        },
        postContent: {
            type: String,
            default: '内容'
        },
        fontObj: {
            type: Object
        }
    },
    computed: {
        fontStyle() {
            return this.fontObj
            ? Object.assign({}, this.fontObj, {
                fontSize: `${this.fontObj.fontSize}px`
            })
            : {}
        }
    }
}
</script>

<style lang="less">
.de-introduce-wrapper {
    text-align: center;
    font-size: 16px;
    font-family: "PingFang";
    .num {
        font-weight: bold;
        font-size: 20px;
    }
}
</style>